// DS: i12.4
import React from 'react';
import IconWrap, {Props} from '../../IconWrap';

const StudioStash: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M3.5 3a1 1 0 1 0 0 2h17a1 1 0 1 0 0-2zm5 8.53a1 1 0 0 0 1 1h5a1 1 0 1 0 0-2h-5a1 1 0 0 0-1 1"
        ></path>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M4 7.76a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm2 1V19h12V8.76z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
StudioStash.displayName = 'StudioStash';

export default StudioStash;
